module.exports = __webpack_public_path__ + "img/edifier-connect.7af77b9a.webp";